import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CurrencyPoundIcon(props: IconProps) {
    return <Icon {...props} iconKey={"currency_pound"}/>
}
